import { useOktaAuth } from '@okta/okta-react'
import { createOktaPreviewAuth, setOktaPreview } from '~/shared/config/auth'
import { Button, Footer, Logo, OptiMagnifyingGlass } from '~/shared/ui'

const showOktaPreview = import.meta.env.VITE_DEPLOYMENT_STAGE === 'dev'

export function LoginPage() {
  const { oktaAuth } = useOktaAuth()

  const handleOktaPreviewSignIn = () => {
    setOktaPreview(true)
    const previewAuth = createOktaPreviewAuth()
    previewAuth.signInWithRedirect()
  }

  return (
    <div className="relative flex h-screen min-h-[768px] min-w-[1280px] flex-col">
      <header className="flex h-[72px] items-center px-6">
        <Logo />
      </header>
      <div className="flex-1">
        <div className="absolute top-1/2 left-1/2 flex w-[460px] -translate-1/2 flex-col items-center rounded-lg shadow-[0px_3px_13px_0px_rgba(0,0,0,0.04),0px_10.5px_36px_0px_rgba(0,0,0,0.19)]">
          <div className="mt-1">
            <OptiMagnifyingGlass />
          </div>
          <div className="mt-3 text-xl leading-6 font-medium tracking-[0.15px]">Welcome</div>
          <div className="text-text-secondary mt-2 text-[17px] leading-6 tracking-[0.5px]">
            Sign in to access your account
          </div>
          <div className="mt-8 mb-6 w-full px-6">
            <Button
              className="w-full"
              size="large"
              raised
              materialIcon="login"
              onClick={() => oktaAuth.signInWithRedirect()}
            >
              Sign in with Okta
            </Button>
            {showOktaPreview && (
              <Button
                className="mt-2 w-full"
                size="large"
                tonal
                materialIcon="login"
                onClick={handleOktaPreviewSignIn}
              >
                Sign in with Okta Preview
              </Button>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}
